import bmLogoImg from "@img/logos/bankmonitor.svg";
import autobind from "autobind-decorator";
import { Button, PromisePool } from "bm-ui-kit";
import type { ReactNode } from "react";
import React from "react";
import { Ad } from "../Ad/Ad";

interface Props {
	onClosed: (hasBanner: boolean) => void;
}

interface State {
	show: boolean;
	countDown: number;
}

export class InterstitialBlock extends React.Component<Props, State> {
	private readonly promisePool = new PromisePool();

	public constructor(props: Props) {
		super(props);

		this.state = {
			show: false,
			countDown: 4,
		};
	}

	public componentWillUnmount(): void {
		this.promisePool.cancel();
	}

	public render(): ReactNode {
		const { show: showInfo, countDown } = this.state;

		return (
			<div
				className={`fixed-top w-100 h-100 position-fixed bg-white flex-column justify-content-center animated ${
					showInfo ? "d-flex fadeIn faster" : "d-none"
				}`}
			>
				<div className="bg-light border-bottom py-2">
					<div className="d-flex align-items-center container">
						<img src={bmLogoImg} alt="Bankmonitor.hu" width="160" height="23" loading="lazy" />
						<div className="ml-auto pl-3 text-right">
							Az oldal {countDown} másodpercen belül betöltődik.
							<br />
							<Button variant="link" className="font-weight-bold" onClick={this.onClose}>
								Kattints a folytatáshoz &gt;&gt;
							</Button>
						</div>
					</div>
				</div>
				<div className="d-flex h-100 justify-content-center align-items-center">
					<Ad
						name="Interstitial"
						code="6551542"
						type="desktop"
						width="970"
						height="550"
						priority={999}
						onLoaded={this.onLoaded}
					/>
				</div>
			</div>
		);
	}

	@autobind
	private onClose(): void {
		const { onClosed } = this.props;

		onClosed(true);
	}

	@autobind
	private onLoaded(hasBanner: boolean) {
		const { onClosed } = this.props;

		if (hasBanner) {
			this.setState({
				show: true,
			});

			this.promisePool.addTimeout(1_000).then(() => {
				this.onTick();
			});
		} else {
			onClosed(false);
		}
	}

	@autobind
	private onTick() {
		const { onClosed } = this.props;
		const { countDown } = this.state;

		if (countDown > 0) {
			this.setState({
				countDown: countDown - 1,
			});

			this.promisePool.addTimeout(1_000).then(() => {
				this.onTick();
			});
		} else {
			onClosed(true);
		}
	}
}
